module.exports = __webpack_public_path__ + "media/images/emblems/Vugelles-La_Mothe-coat_of_arms-479cf7574bc35c167f367ac84f852cf7.svg";